export default "/aWETH.8701b6193cb2112d5dfb5e53709b5a06.png";